<template>
   <div>
    <v-row dense="" class="alphabet-section ml-0">
      <v-col cols="12" class="text-center">
        <v-btn
          elevation="2"
          max-width="22"
          min-width="22"
          height="20"
          small
          style="font-size:15px;"
          :class="(selected_alphabet == '')?'primary':''" 
          class="text-capitalize"
          @click="setData({key : 'selected_alphabet',value : ''})"
        >
          All
        </v-btn>
      </v-col>
      <v-col cols="12" v-for="(alphabet, index) in alphabets" :key="index" class="text-center pa-0" style="padding-top: 6px !important;">
        {{search}}
        <v-btn
          elevation="2"
          max-width="22"
          min-width="22"
          height="20"
          small
          style="font-size:15px;"
          :disabled="alphabet.disable"
          :class="(selected_alphabet == alphabet.value)?'primary':''" 
          @click="setData({key : 'selected_alphabet',value : alphabet.value})"
        >
        {{alphabet.text}}
        </v-btn>
      </v-col>
    </v-row>
   </div>
</template>

<script>
//import { getAlphabets } from "../plugins/helper";
import { mapState,mapMutations } from "vuex";
export default {
  name : 'AlphabetSort',
  data(){
    return {
      search:'',
    }
  },
  methods : {
    ...mapMutations("submenu", ["setData"]),
  },
  computed : {
    ...mapState("submenu", ["selected_alphabet","alphabets"]),
  }
}
</script>

<style>

</style>